import { BiTrackService } from '@eureka/domains/src/bi-track/services/bi-track-service';
import { injectService } from '@patsnap/tahiti-core';
import { createSharedComposable } from '@vueuse/core';
import { getBrowserFingerprint } from '@patsnap-utils/browser-fingerprint';
import { InitCookie } from '@patsnap/init-cookie';

export const useTracking = createSharedComposable(() => {
  const getAgentSource = () => {
    // 1. Get the hash fragment (everything after #)
    const hash = window.location.hash;
    // 2. Extract the query string portion from the hash
    const queryString = hash.split('?')[1];
    // 3. Parse with URLSearchParams
    const params = new URLSearchParams(queryString);
    const startFrom = params.get('start_from') || 'agent_home';

    return startFrom;
  };

  const sendTracking = async (eventName: string, sourceType: string, others?: Record<any, any>) => {
    const biTrackService = injectService<BiTrackService>(BiTrackService);
    const fingerprint = (await getBrowserFingerprint()) as unknown as string;

    biTrackService.biTrack(eventName, {
      sourceType,
      eventDetailStr: {
        agentSource: getAgentSource(),
        signatureId: fingerprint,
        campaignName: InitCookie.getCampaignName(),
        ...others, // prioritised
      },
    });
  };

  return {
    getAgentSource,
    sendTracking,
  };
});
